import content from './releaseNotes.md'

export const getReleaseNotes = () => {
  return fetch(content)
    .then((c) => c.text())
    .then((md) => md)
}
